import React, { useState, useEffect } from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
// import PositionImageViewModal from './viewImageModal';

import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import ItemPageContainer from "layouts/itemPageContainer";

import CardItem from "components/alove/CardItem";
import {
  avatarUrl,
  camelCaseToCapitalizedWords,
  camelcaseToSnakeCase,
  formatDate,
} from "utils/globalsUtils";
import { SMEHeader } from "layouts/itemPageContainer/userItem/profileHeader";
import { getByUserId } from "utils/enduserUtils";
import { EndUser } from "models/profile/EndUser";
import { addAlert, setCurrentDialog, useAuth, useMaterialUIController, useTranslations } from "context";
import { Profile, ProfileAsset, ProfileStatus } from "models/profile/Profile";

const MDInput = require("components/MDInput/index.js").default;
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { getAttribute } from "utils/attributesUtil";
import { Attribute } from "models/profile/Attribute";
import {
  deleteQuestion,
  getQuestion,
  questionnaires,
  questionnarieListDo,
  updateBatchContentDO,
  updateQuestion,
} from "utils/questionsUtils";
import { Question, QuestionType, ResponseType, ScoringType } from "models/batch/Question";
import { QuestionHeader } from "./component/question";
import { Answers } from "./component/answers";
import { PermissionType } from "models/BO/BoRole";
import { Prevalidate } from "./component/prevalidate";
import { Autoresponse } from "./autoresponse";
import { QuestionQuestionnaires } from "./component/questionnaires";
import { AlgorithmSettings } from "./component/algorithmSettings";
import { DialogType } from "components/alove/AloveDialog";
import { CreateAttributeModal } from "./component/createAttributeModal";
import { ItemHeader } from "layouts/itemPageContainer/userItem/itemHeader";
import { AnswerSettings } from "./component/answerSettings";
import { BatchContent } from "models/batch/BatchContent";
import { PreValidation } from "models/batch/PreValidation";
import { PageNumber } from "../../../accessNumbers";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
const MDSnackbar = require("components/MDSnackbar/index.js").default;
let newStatus = ProfileStatus.Active;

function ViewQuestion() {
  const pageNumber = PageNumber.ViewQuestion;
  const [controller, dispatch] = useMaterialUIController();
  const { currentRole } = useAuth();
  const { currentLanguage } = useTranslations();
  const isAdmin = true;
  const [inputErrors, setInputErrors] = useState({});

  const navigate = useNavigate();

  const [loader, setLoader] = useState(true);

  const [question, setQuestion] = useState<Question>({} as Question);

  let { id } = useParams();

  const [queryParameters] = useSearchParams();
  const [filter, setFilter] = useState(queryParameters.get("filter") || "");

  useEffect(() => {
    if (id) {
      questionnarieListDo();
      getQuestion(id!).then((res) => {
        setLoader(false);
        res.responses.sort((a, b) => a.ordinal - b.ordinal);
        setQuestion(Object.assign(new Question(), {
          ...res,
          batchContents: res.batchContents.map(bc => Object.assign(new BatchContent(), bc))
        }));
      });
    }
  }, [id, currentLanguage]);

  const _updateQuestion = async (question, serverUpdate = true) => {
    setQuestion(question);
    if (serverUpdate) {
      return updateQuestion(question.id, question);
    }
  };


  const _updateBatchContentStatus = async (batchContent, status) => {
    batchContent.contentStateId = status;
    _updateQuestion({ ...question, batchContents: [batchContent] }, false);
    return updateBatchContentDO(batchContent.id, batchContent);
  }

  const _updatePrevalidation = async (preValidation: PreValidation[]) => {
    if (question.batchContents?.[0]) {
      question.batchContents[0].preValidation = preValidation;
      _updateQuestion({ ...question, batchContents: [question.batchContents?.[0]] }, false);
      return updateBatchContentDO(question.batchContents[0].id, question.batchContents[0]);
    }
  }

  return (
    <DashboardLayout>
      <DashboardNavbar pageTitle={question?.id?.toString()} />
      <ItemPageContainer
        loader={loader}
        navItems={[
          { label: "Question" },
          { label: "Answers", ref: "answers" },
          { label: "Answer Settings", ref: "answer-settings" },
          { label: "Algorithm Settings", ref: "algorithm-settings" },
          { label: "Auto Responses", ref: "autoresponse" },
          { label: "Pre-validate", ref: "pre-validate" },
          { label: "Attached Questionnaires", ref: "questionnaires" },

        ]}
        itemHeader={<ItemHeader title="Question Details"
          indications={[
            { title: "Type", value: QuestionType[question?.questionType] },
            { title: "Scoring Type", value: ScoringType[question?.scoringTypeId] },
            { title: "Response Type", value: camelCaseToCapitalizedWords(ResponseType[question?.responseType]) },
          ]}
        />}
        itemStatus={{
          item: question.batchContents?.[0],
          title: "Question Status",
          isManager: true,
          changeStatus: (status) => _updateBatchContentStatus(question.batchContents?.[0], status)
        }}

        actions={{
          pageNumber,
          itemName: `Question`,
          itemNumber: `ID: ${id}`,
          actionsTitle: "Question Actions",
          actions: [
            {
              title: "View Attribute",
              hidden: !question.profileAttr,
              onClick: () => {
                navigate(`/attributes/${question.profileAttr}`);
              },
            },
            {
              title: "Create Attribute",
              hidden: !!question.profileAttr,
              onClick: () => setCurrentDialog(dispatch, DialogType.AddAttribute),
            },
            {
              title: "View Answers List",
              onClick: () => {
                navigate(`/questions/${question.id}/answers`);
              },
            }
            // {
            //   title: "Old Question View",
            //   role: PermissionType.ViewAllOptions,
            //   onClick: () => {
            //     const bname =
            //       Object.entries(questionnaires).find(
            //         ([key, value]) => value == question.batchContents[0].batchId
            //       )?.[0] || "";

            //     navigate(`/questionnaires/${camelcaseToSnakeCase(bname)}/${question.id}`);
            //   },
            // },
          ],
        }}
        deleteItem={{
          contetnText: "Are you sure you want to delete this question? All responses also will be deleted.",
          buttonText: "Delete",
          hidden: !currentRole.hasAccess(PageNumber.ViewQuestion, PermissionType.Delete),
          onDelete: () => {
            return deleteQuestion(question.id).then(() =>
              navigate(-1)
            );
          }

        }}
      >
        <CardItem title="Question Details" id="question">
          <QuestionHeader question={question} setQuestion={_updateQuestion} />
        </CardItem>

        <CardItem title="Answers" id="answers">
          <Answers question={question} setQuestion={setQuestion} />
        </CardItem>

        {[ResponseType.MultipleChoice, ResponseType.Text].includes(question.responseType) && (
          <CardItem title="Answer Settings" id="answer-settings" defaultClosed>
            <AnswerSettings question={question} setQuestion={_updateQuestion} />
          </CardItem>
        )}


        <CardItem title="Algorithm Settings" id="algorithm-settings" defaultClosed>
          <AlgorithmSettings question={question} setQuestion={_updateQuestion} />
        </CardItem>
        <CardItem title="Auto Responses" id="autoresponse" defaultClosed>
          <Autoresponse questionId={question.id} answers={question.responses || []} />
        </CardItem>

        <CardItem title="Pre-validate" id="pre-validate" defaultClosed>
          <Prevalidate
            preValidation={question.batchContents?.[0]?.preValidation || []}
            updatePrevalidation={_updatePrevalidation}
          />
        </CardItem>

        <CardItem title="Attached Questionnaires" id="questionnaires" defaultClosed>
          <QuestionQuestionnaires question={question} />
        </CardItem>
      </ItemPageContainer>
      <CreateAttributeModal question={question} />
    </DashboardLayout>
  );
}

export default ViewQuestion;
